var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Select } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';
import { CriteriaGroupType, CriteriaTerminalType } from '../../types';
import useCriteriaCardOptions from '../../hooks/useCriteriaCardOptions';
export default function CriteriaCardSelect(_a) {
    var name = _a.name, _b = _a.root, root = _b === void 0 ? false : _b, _c = _a.patronOnly, patronOnly = _c === void 0 ? false : _c;
    var selectDefaultValue = useMemo(function () {
        if (root) {
            return CriteriaTerminalType.PASS;
        }
        else {
            return CriteriaGroupType.ALL_OF;
        }
    }, [root]);
    var intl = useIntl();
    var selectOptions = useCriteriaCardOptions(root, patronOnly);
    return (React.createElement(Field, { name: name, defaultValue: selectDefaultValue, "aria-label": intl.formatMessage({
            id: 'ui-plugin-bursar-export.bursarExports.criteria.select.label',
        }) }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { required: true, marginBottom0: true, dataOptions: selectOptions }))); }));
}
